// 1
import col1 from "../image/col1.avif";
import col1_1 from "../image/col1-1.avif";
import col1_2 from "../image/col1-2.avif";

// 2
import col2 from "../image/col2.avif";
import col2_1 from "../image/col2-1.avif";
import col2_2 from "../image/col2-2.avif";

// 3
import col3 from "../image/col3.avif";
import col3_1 from "../image/col3-1.avif";
import col3_2 from "../image/col3-2.avif";

// 4
import col4 from "../image/col4.avif";
import col4_1 from "../image/col4-1.avif";
import col4_2 from "../image/col4-2.avif";

// 5
import col5 from "../image/col5.avif";
import col5_1 from "../image/col5-1.avif";
import col5_2 from "../image/col5-2.avif";

// 6
import col6 from "../image/col6.avif";
import col6_1 from "../image/col6-1.avif";
import col6_2 from "../image/col6-2.avif";
import col6_3 from "../image/col6-3.avif";
import col6_4 from "../image/col6-4.avif";

// 7
import col7 from "../image/col7.avif";
import col7_1 from "../image/col7-1.avif";
import col7_2 from "../image/col7-2.avif";
// 8
import col8 from "../image/col8.avif";
import col8_1 from "../image/col8-1.avif";
import col8_2 from "../image/col8-2.avif";
// 9
import col9 from "../image/col9.avif";
import col9_1 from "../image/col9-1.avif";
import col9_2 from "../image/col9-2.avif";
import col9_3 from "../image/col9-3.avif";
// 10
import col10 from "../image/col10.avif";
import col10_1 from "../image/col10-1.avif";
import col10_2 from "../image/col10-2.avif";
import col10_3 from "../image/col10-3.avif";
// 11
import col11 from "../image/col11.avif";
import col11_1 from "../image/col11-1.avif";
import col11_2 from "../image/col11-2.avif";
import col11_3 from "../image/col11-3.avif";
// 12
import col12 from "../image/col12.avif";
import col12_1 from "../image/col12-1.avif";
import col12_2 from "../image/col12-2.avif";
import col12_3 from "../image/col12-3.avif";

export const productList = [
  {
    category: "Our favourite finds on Folksy",
    list: [
      {
        id: 1,
        title:
          "Greetings Card - Stained glass 'Polar Bear in a time of change’",
        detail: [
          [
            "Full description",
            "A high quality printed greetings card with a stylish image of one my stained glass panels showing a polar bear against a background of plants and ice.. Ideal for birthdays and other occasions.",
            `Size: 152mm x 152mm (approx 6" x 6")`,
            "Good quality 300gsm white card",
            "The card is blank inside so you can add your own personal message. It comes with a white envelope and packed in a biodegradable wrapper.",
            "Also see my multipack offer if you'd like to buy more than one of my greetings cards.",
          ],
          [
            "Inspiration",
            "Stained glass is beautiful but I can't keep everything that I make! After I'd been making stained glass for a while I decided to keep a memento of my best pieces and started to take photos of my favourites. After a while these became the inspiration for my range of greetings cards, with each card having an image of an original piece of stained glass. I am gradually adding to my range of cards, always using images of my own original artwork.",
            "Do get in touch for larger orders, or for information about trade sales.",
          ],
        ],

        quantity: 1,
        image: [col1, col1_1, col1_2],
        price: "2.95",
        total: "2.95",
      },
      {
        id: 2,
        title: "Black Walnut Flower Clock with Copper Gilt features:SKU Clox23",
        detail: [
          [
            "Full description",
            "This clock is based on a previous design, but this is a smaller version in black Walnut with hand gouged details for the copper leaf gilding to be laid into. Due to its size this was a hard clock to hand shaped and carve.",
            "To get the shape it required several iterations to get the petals that we wanted, from six petals to the one we have which is a five petal version. Finally, this was finished with sanding sealer then melamine lacquer and finished with Carnauba wax. This item is number 23 and this is pyrographed on the back. Clock movement is a UTS quartz movement with aluminium metal flake gilded hands, which is made in Germany and are exposed so care must be taken with these hands.",
            "Dimensions: 12.25cm (4.8”) overall diameter, 2.5cm (1”) thick. Weight 0.15kg",
            "This clock is made from organic, natural, solid wood and will distort if put near a heat source such as a radiator, it will also discolour if left in direct sunlight. The item you see here is the one you will receive and I have aimed to provide dimensions which are as accurate as possible. Please note that wood is a natural product and can be affected by its environment.",
          ],
          [
            "Inspiration",
            "As technology changes and the requirement for a house clock disappears these clocks are a statement, a visual icon of the natural world using different timbers and fixings to remind us of the outside world. This clock is made from timber that is recycled and re-purposed to make this clock individual. It is marked with its own unique number on the base.Our modern day lives are a rush and we need something to remind us not to rush but enjoy our time. This clock is one of those things where we can enjoy the different colours and grain textures, when time allows us to grab some downtime. As time goes on and thoughts change so will the types and designs change, just like the seasons we constantly look at different ideas in a different light.",
          ],
        ],
        quantity: 1,
        image: [col2, col2_1, col2_2],
        price: "35.00",
        total: "35.00",
      },
      {
        id: 3,
        title: "Original acrylic landscape painting, art, landscape painting",
        detail: [
          [
            "Full description",
            "Original acrylic landscape painting",
            "On handmade acid free cotton paper.",
            "Deckle edge",
            "A6- approx 15cm x 11cm",
            "Signed",
            "I love to paint landscapes with an eye catching sky.",
            "Please take a look in my shop",
            "Thanks for taking the time to look",
          ],
        ],

        quantity: 1,
        image: [col3, col3_1, col3_2],
        price: "20.00",
        total: "20.00",
      },
      {
        id: 4,
        title: "Meditation Stone, Wrapped Rock",
        detail: [
          [
            "Full description",
            "I have created this hand wrapped stone following the Japanese method of Mizuhiki, or embellishing a gift, using weaving and knot techniques.",
            "Firstly, I select a stone for its size, shape and texture. Then I hand wrap it in rattan cane, securing the ends by wrapping back underneath. This means no glue or fixings have been used, resulting in an entirely natural object.",
            "This stone is one of my smaller ones, making it ideal to roll in your hand while thinking or meditating.",
            "This stone is designed to be picked up and handled, use as a desk ornament or simply place on a shelf within easy reach to be admired.",
            "A lovely sustainable gift, ideal as a yoga meditation stone or set within a nautical bath ground.",
            "9cm x 7cm x 4cm",
          ],
        ],
        quantity: 1,
        image: [col4, col4_1, col4_2],
        price: "24.00",
        total: "24.00",
      },
    ],
  },
  {
    category: "Theme of the day: Carved By Hand",
    list: [
      {
        id: 5,
        title: "Ceramic Bowl",
        detail: [
          [
            "Full description",
            "Small bowl with fish scale design.",
            "This bowl is made with a grogged stoneware clay which gives a speckled texture. It is hand carved with white satin glaze and white interior.",
            "Approx. Size: 5cm high x 8cm diameter",
          ],
        ],
        quantity: 1,
        image: [col5, col5_1, col5_2],
        price: "38.00",
        total: "38.00",
      },
      {
        id: 6,
        title:
          "Red Cabbage & Cranberries - Woodcut Print - Original Art for the Kitchen",
        detail: [
          [
            "Full description",
            "After printmaking and gardening, I also love creating in the kitchen. This hand-coloured woodcut shows the ingredients for Red Cabbage & Cranberries - a favourite Christmas and Winter side dish",
            "Hand-carved woodcut printed on 60% cotton rag soft-white Fabriano Rosaspina 285gsm, coloured with artists watercolours, signed and titled",
            "Original woodcut in un-numbered edition, very slightly variable as printed and coloured by hand",
            "NB Blue watercolour may not display correctly on screen - the blue in this woodcut is ultramarine",
            "Image size 125mm x 90mm, paper size 200mm x 170mm",
            "Woodcuts are sold unframed and without a mount, and sent in a card-backed recyclable clear protective sleeve, packaged with more cardboard",
          ],
          [
            "Inspiration",
            "This is one of my favourite Winter vegetable sides, it also has lots of fruit and is really colourful as well as being very tasty ... recipe on request ...",
          ],
        ],
        quantity: 1,
        image: [col6, col6_1, col6_2, col6_3, col6_4],
        price: "20.00",
        total: "20.00",
      },
      {
        id: 7,
        title: "Beech Wood Serving Spoon in Blue and White",
        detail: [
          [
            "Full description",
            "A curvy hand carved Beech wood serving spoon. The spoon has a large, deep bowl perfect for serving up that home cooked dinner. Its also sturdy and capable of being used for stirring duties too. The handle has been coloured using milk paint, in Soldier Blue and Snow White colours.",
            "This spoon has been made using traditional methods splitting the material out from a fresh sawn log, sourced from a local tree surgeon. A rough shape for the spoon is then axed out, before moving onto a variety of knives to hone the shape. Once dry, the spoon handle has been painted with (food safe) old fashioned milk paint, then burnished with a smooth scottish pebble. My makers mark has been burned on and finally its been sealed using organic food grade linseed oil.",
            "Spoon care-",
            "Your spoon is designed to be loved and used, and with time it'll develop a beautiful 'used' patina. To clean your spoon- simply hand wash in soapy water, rinse and leave to dry. Do not leave your spoon soaking for long periods in water or wash in a dishwasher.",
            "Your spoon will be dispatched to you in recycled, eco-friendly and plastic-free packaging, and this can be placed directly into composting or your paper recycling bin.",
          ],
          [
            "Inspiration",
            "Cooking is an integral part of all our lives, and using a beautiful hand crafted wooden spoon is a delight. I love making cooking and serving spoons as they have the potential to see use every single day without any effort. As always, using naturally wind blown trees or those felled by arborists feels like a great way to keep the tree alive with a new lease of life! A stunning spoon like this makes a great gift to yourself or others.",
          ],
        ],
        quantity: 1,
        image: [col7, col7_1, col7_2],
        price: "30.00",
        total: "30.00",
      },
      {
        id: 8,
        title: "End Grain Spalted Beech Pinch Pot with Turquoise Base",
        detail: [
          [
            "Full description",
            "A spalted beech wood end-grain pinch pot, turned on a traditional pole lathe. The outer base of the pot is finished in striking turquoise milk paint which compliments the beautiful spalted wood well. A wonderful little pinch pot for dry goods, or something special like jewellery or trinkets.",
            "This pot has been made using traditional methods splitting the material out from a fresh sawn log, sourced from a local tree surgeon. The wood has then been mounted onto my pole lathe and turned before being allowed to dry, and the pot taking on its final natural shape. A pole lathe is an ancient leg-powered lathe commonly used in the medieval era. No power other than the woodworker’s own is used, and it’s a slower, more involved process than rapidly made electric turned items. As no sanding is used in this process, it’s normal to be able to see the passage of the lathe hook tools on the surface of the item. Once dry, the base has been painted with (food safe) old fashioned milk paint, and finally the pit has been sealed using organic food grade linseed oil.",
            "Pot care-",
            "Your pot is not suitable for storing wet items. If it should require a clean, just wipe with a damp cloth and allow to air dry fully.",
            "Your pot will be dispatched to you in recycled, eco-friendly and plastic-free packaging, and this can be placed directly into composting or your paper recycling bin.",
          ],
          [
            "Inspiration",
            "A little pot like this is wonderful to see and use. If you could jump back to the medieval era or even earlier, you would have been able to see such pots in people’s homes. Made from green wood these containers are about as natural as you can get, free from plastic or resin or all the other unnecessary additions of the modern world! As always, using naturally wind blown trees or those felled by arborists feels like a great way to keep the tree alive with a new lease of life! A stunning pot like this makes a great gift to yourself or others.",
          ],
        ],
        quantity: 1,
        image: [col8, col8_1, col8_2],
        price: "25.00",
        total: "25.00",
      },
    ],
  },
  {
    category: "Donate to Charity",
    list: [
      {
        id: 9,
        title: "Blue and Green Netted Necklace",
        detail: [
          [
            "Full description",
            "An attractive blue and green necklace with hints of purple in the tiny seed beads from which the 'net' is made. It would make a lovely gift as it goes equally well with a smart outfit or with jeans and a t-shirt.",
            "Pretty 4mm Czech glass beads in iris blue (a deep blue with purple overtones), transparent light sapphire and shamrock green have been encased in a netting stitch made with tiny iridescent blue/ purple seed beads. This makes a substantial but delicate looking necklace with medium flexibility and drape. A silver-plated trigger clasp completes the piece.",
            "The netted design is a fairly classic beadweaving design. The beads are actually stitched into place inside their 'net'. Any available colours can be used. For this necklace I was trying to replicate the beautiful colours of a peacock. I would be happy to make you a necklace in this design to your requirements in both colour and length and would give you a price quote for approval before we agreed to proceed.",
            "The necklace is 47.6cms (18.75ins) long and about 0.9cm (0.35ins) in diameter.",
            "The necklace will be sent wrapped in acid-free tissue paper and posted in a sturdy cardboard box for safe travel.",
            "WHEN YOU BUY THIS ITEM £9 WILL BE DONATED TO TOYBOX, A CHARITY HELPING STREET CHILDREN ACROSS THE GLOBE. This amount is calculated by subtracting materials and admin costs from the price of the item. I do not charge for my time in making it.",
          ],
        ],
        quantity: 1,
        image: [col9, col9_1, col9_2, col9_3],
        price: "26.00",
        total: "26.00",
      },
      {
        id: 10,
        title: "Crystal Necklace in Olive Green and Antique Gold",
        detail: [
          [
            "Full description",
            "An elegant row of 26 olive green 6mm Swarovski bicone (Xilion) crystals, linked with antique gold plated pins makes a pretty necklace, finished with fine curb chain and a trigger clasp in the same colour as the pins. The Swarovski name for the colour of the crystals is Olivine AB. The AB coating is a thin metallic coating on some of the facets which gives a mirror-like finish thus helping to make them sparkle in the light.",
            "The necklace is 45.2cms (17.8ins) long. It will be sent wrapped in acid-free tissue paper in a sturdy cardboard box for safe postage.",
            "WHEN YOU BUY THIS ITEM £1 WILL BE DONATED TO TOYBOX, A CHARITY HELPING STREET CHILDREN ACROSS THE GLOBE. This amount is calculated by subtracting materials and admin costs from the price of the item. I do not charge for my time in making it.",
          ],
        ],

        quantity: 1,
        image: [col10, col10_1, col10_2, col10_3],
        price: "10.00",
        total: "10.00",
      },
      {
        id: 11,
        title: "Mint Green Freshwater Pearl Necklace",
        detail: [
          [
            "Full description",
            "A lovely gift for someone special: some pretty freshwater pearls which have been dyed a lovely mint green shade, ideal for summer. The shape of the pearls is slightly asymmetrical; these are often referred to as potato pearls. The close-up photo shows the detail.",
            "Each pearl is 7mm to 8mm in diameter. They have generally smooth surfaces with a few minor flaws and a good lustre. I have strung them on silk: the traditional medium, and have knotted between each pearl, an old-fashioned technique that ensures a good drape and also security in the unlikely event that the silk breaks.",
            "I have finished the necklace with sterling silver findings: a tiny bead, French wire (gimp) and a trigger clasp.",
            "I have two of these necklaces available. On necklace is about 50cms (20 ins) long, the other is about 47cms (18.5 ins) long. Please choose the length you require when ordering. Your necklace will be sent wrapped in acid-free tissue paper and posted in a sturdy cardboard box for safe travel.",
            "WHEN YOU BUY THIS ITEM £5 WILL BE DONATED TO TOYBOX, A CHARITY HELPING STREET CHILDREN ACROSS THE GLOBE. This amount is calculated by subtracting materials and admin costs from the price of the item. I do not charge for my time in making it.",
          ],
        ],
        quantity: 1,
        image: [col11, col11_1, col11_2, col11_3],
        price: "38.00",
        total: "38.00",
      },
      {
        id: 12,
        title: "Crystal Starburst Pendant in Sapphire Blue",
        detail: [
          [
            "Full description",
            "This sparkly little pendant in a beautiful sapphire blue shade of Swarovski crystal is ideal for people who like plenty of sparkle but who don’t like big pieces of jewellery; it is only just over an inch in diameter. It is made from no fewer than 35 high quality Swarovski 4mm and 3mm xilion crystals stitched over an 14mm matching Swarovski Rivoli. The outer ring of 4mm crystals are sapphire blue and the inner ring of 3mm crystals are light sapphire. Tiny silver-lined crystal seed beads complete the piece, which is strung on an 18 inch silver plated trace chain with a matching bolt ring clasp.",
            "The pendant is 3cms (1.2ins) in diameter, approximately 5mm (0.4ins) thick and is suspended on a 45.7cms (18ins) silver plated chain.",
            "The pendant will be sent to you wrapped in acid free tissue inside and posted in a sturdy cardboard box.",
            "WHEN YOU BUY THIS ITEM £5 WILL BE DONATED TO TOYBOX, A CHARITY HELPING STREET CHILDREN ACROSS THE GLOBE. This amount is calculated by subtracting materials and admin costs from the price of the item. I do not charge for my time in making it.",
          ],
        ],
        quantity: 1,
        image: [col12, col12_1, col12_2, col12_3],
        price: "17.00",
        total: "17.00",
      },
    ],
  },
];

export const getProductDetailById = (id) => {
  let product;
  for (const item of productList) {
    product = item.list.find((itemProduct) => itemProduct.id === id);
    if (product) return product;
  }
  return undefined;
};

// find
export const getCategoryList = (type) => {
  let list = productList.find((item) => item.category === type);
  return list;
};
